<!-- 组件说明 -->
<template>
  <div class="con">
    <div class="container" v-for="(item, index) in goodsList" :key="item.id">
      <div class="l c-pointer" @click="toDetailPage(item, status)">
        <img v-lazy="item.image ? item.image : $defaultImg" alt="" />
        <div class="mask-time">有效期：{{ item.expireDate }}</div>
      </div>

      <div class="m">
        <h5 class="title">
          <i
            v-if="
              item.goodsActivityInfoMap.activity
                ? item.goodsActivityInfoMap.activity
                : ''
            "
            >{{ item.goodsActivityInfoMap.activityBadge }}</i
          >
          <span class="c-pointer" @click="toDetailPage(item, status)">{{
            item.name
          }}</span>
        </h5>
        <!-- <p class="tip">
          <span>{{ item.promotion }}</span>
        </p> -->
        <div class="info">
          <div class="info-l">
            <p :title="item.name"><span>商品名称</span>：{{ item.name }}</p>
            <!-- <p><span>规格</span>：{{ item.specification }}</p> -->
            <p :title="item.manufacturer">
              <span>生产产商</span>：{{ item.manufacturer }}
            </p>
            <!-- <p><span>批准文号</span>：{{ item.approval }}</p> -->
            <p><span>剂型</span>：{{ item.jixing }}</p>
          </div>
          <div class="info-m">
            <p><span>规格</span>：{{ item.specification }}</p>
            <p><span>批准文号</span>：{{ item.approval }}</p>
            <p>
              <span>整件规格</span>:&nbsp;&nbsp;&nbsp;{{ item.jlgg
              }}{{ item.unit }}
            </p>
          </div>
          <div class="info-r">
            <p><span>中包装</span>：{{ item.zybz }}{{ item.unit }}</p>
            <p>
              <!-- 剂型：<span>{{ item.jixing }}</span > -->
              <span>是否拆零</span>： {{ !item.zhxs ? "是" : "否" }}
            </p>
            
          </div>
        </div>
      </div>
      <div class="r">
        <div v-if="$store.state.hasLogin && !item.isForbidAreaSale">
          <p class="p1"><i>￥</i>{{ item.goodsActivityInfoMap.priceStr }}</p>
          <p class="p2" v-if="item.goodsActivityInfoMap.resetPrice">
            <i>￥</i>{{ item.goodsActivityInfoMap.goodsPriceStr }}
          </p>
        </div>
        <p class="p3" v-if="$store.state.hasLogin && item.isForbidAreaSale">
          地区禁售<br />价格不可见
        </p>

        <!-- <inputNum
          class="num"
          ref="inputNumber"
          :maxNumber="
            item.stock > item.goodsActivityInfoMap.limitedCount
              ? item.goodsActivityInfoMap.limitedCount
              : item.stock
          "
          :skuNum="item.zhxs ? item.zybz : ''"
          v-if="item.goodsActivityInfoMap.limited"
        ></inputNum>
        <inputNum
          class="num"
          :maxNumber="item.stock"
          ref="inputNumber"
          :skuNum="item.zhxs ? item.zybz : ''"
          v-else
        ></inputNum>
        <div
          class="addcert c-pointer"
          v-if="item.stock > 0 && !item.isForbidAreaSale"
          @click="add(item, index)"
        >
          加入购物车
        </div>
        <div
          class="short c-pointer"
          v-if="item.stock == 0 && !item.isForbidAreaSale"
          @click="prePay(item.id)"
        >
          到货提醒
        </div> -->
        <div class="forbid no-select" v-if="item.isForbidAreaSale">
          地区禁购
        </div>
      </div>
    </div>
    <popup
      class="popup-info"
      width="350px"
      height="200px"
      @close="close"
      v-if="show"
    >
      <div v-if="type == 1">
        <img
          class="close"
          :src="require('@/assets/images/icon_xx3.png')"
          alt=""
          @click="close"
        />
        <div class="title">该商品暂无库存，确定预购吗</div>
        <div class="btn">
          <span class="span1" @click="confirm">确定</span>
          <span class="span2" @click="close">取消</span>
        </div>
      </div>

      <div v-if="type == 2">
        <div class="header">
          <span>出错提示</span>
          <img
            class="close2"
            :src="require('@/assets/images/x.png')"
            alt=""
            @click="close"
          />
        </div>
        <div class="middle">
          <img
            class="errimg"
            :src="require('@/assets/images/t_s.png')"
            alt=""
          />
          <span>{{ message }}</span>
        </div>
      </div>
    </popup>
    <success v-if="successShow">{{ message }}</success>
  </div>
</template>

<script>
import inputNum from "@/components/input-number";
export default {
  components: {
    inputNum,
  },
  props: ["goodsList", "status"],
  data() {
    return {
      show: false,
      itemId: "",
      successShow: false,
      message: "",
      num: "",
      type: 1,
    };
  },
  computed: {},
  methods: {
    isZGS(name) {
      return name.indexOf("珍贵膳") != -1;
    },
    toDetailPage(item, status) {
      // this.$router.push({
      //   name: "detail",
      //   query: {
      //     goodsId: item.id,
      //     type: 1,
      //     status,
      //     keyword: this.$route.query.keyword,
      //   },
      // });
      let routeData = this.$router.resolve({
        path: `/detail?goodsId=${item.id}&type=1&keyword=${this.$route.query.keyword}`,
      });
      window.open(routeData.href, "_blank");
    },
    getNumber(data) {
      if (data) {
        this.num = data;
      } else {
      }
    },
    add(item, index) {
      if (!this.$store.state.hasLogin)
        return this.$router.push({ path: "/login" });
      let num = this.$refs.inputNumber[index].number;
      let id = item.id;
      this.$api
        .POST_ADDCART({
          cartItemType: "goods", //
          id,
          quantity: num,
        })
        .then((res) => {
          if (res.status) {
            this.message = "加购成功";
            this.successShow = true;
            this.$store.commit(
              "GETCARTCOUNT",
              Number(this.$store.state.cartNum) + Number(num)
            );
            this.ANALYSISSAVE(item, 1);
          } else {
            this.show = true;
            this.message = res.message;
            this.type = 2;
          }
        });
    },
    success() {
      this.successShow = false;
    },
    prePay(id) {
      if (!this.$store.state.hasLogin)
        return this.$router.push({ path: "/login" });
      this.show = true;
      this.type = 1;
      this.itemId = id;
    },
    close() {
      this.show = false;
    },
    confirm() {
      this.$api
        .POST_SUBSCRIBESAVE({
          goodsId: this.itemId,
          quantity: 1,
        })
        .then((res) => {
          if (res.status) {
            this.message = "预购成功";
            this.successShow = true;
          }
          this.show = false;
        });
    },
    ANALYSISSAVE(gooodsDetail, savetype) {
      let domain = "http://www.dgsjyyy.com";
      let source = "web";
      let goodsId = gooodsDetail.id;
      let content = gooodsDetail.name;
      let goodsName = gooodsDetail.name;
      let keyword = this.$route.query.keyword;
      let url;
      let title;
      let type;
      if (savetype == 1) {
        (title = "加入购物车"), (type = "cart");
      } else {
        (title = "访问商品"), (type = "detail");
      }
      //  url = "http://www.dgsjyyy.com/main/detail?goodsId="+ gooodsDetail.id +'&type=1'
      url = `http://www.dgsjyyy.com/detail?goodsId=${gooodsDetail.id}&type=1`;

      this.$api
        .POST_ANALYSISSAVE({
          domain,
          source,
          title,
          type,
          url,
          content,
          goodsId,
          goodsName,
          keyword,
        })
        .then((res) => {})
        .catch((err) => console.log(err));
    },
  },
  mounted() {},
  created() {},
};
</script>

<style lang='scss' scoped>
.container {
  width: 1200px;
  min-height: 174px;
  display: flex;
  position: relative;
  background-color: #ffffff;
  border-bottom: 1px solid #eeeeee;
  padding: 14px 0 14px;
  transition: transform 0.2s;
  border-radius: 4px;
  &:hover {
    box-shadow: 0 0 10px 5px #f0f0f0;
    transform: translateY(-5px);
  }
}
.l {
  position: relative;
  width: 150px;
  height: 150px;
  margin: 0 24px;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  overflow: hidden;
  img {
    margin-left: 10%;
    @include size(80%, 80%);
  }

  .mask-time {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 22px;
    width: 100%;
    color: #fff;
    background-color: #ff5151;
    // opacity: 0.3;
    line-height: 22px;
    text-align: center;
  }
}
.m {
  width: 800px;
  .title {
    font-size: 14px;
    color: #505050;
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      //  width: 40px;
      padding: 0 6px;
      height: 20px;
      border: 1px solid #fa4b4b;
      margin-right: 8px;
      border-radius: 3px;
      @include font(12px, #fa4b4b, center, 400, 19px);
    }
  }
  .tip {
    display: inline-block;
    background-color: #fff1f1;
    padding: 0 8px;
    margin: 10px 0;
    @include font(12px, #ff5151, left, 400, 20px);
  }
  .info {
    display: flex;
    font-size: 13px;
    color: #333333;
    width: 830px;
    height: 86px;
    background-color: #fafafa;
    padding: 10px 20px;
    p {
      //   line-height: 20px;
      padding-bottom: 10px;
    }
    .info-l {
      width: 40%;
      padding-right: 10px;
    }
    .info-l,
    .info-m,
    .info-r {
      p {
        @include textLineClamp(1);
        span {
          display: inline-block;
          width: 60px;
          text-align-last: justify;
        }
      }
    }
    .info-m {
      width: 40%;
      padding-right: 10px;
      // margin-right: 100px;
    }
    .info-r {
      .stock-color label {
        color: #fa4b4b;
      }
      // margin-right: 100px;
    }
  }
}
.r {
  position: absolute;
  right: 26px;
  text-align: right;
  top: 50%;
  transform: translateY(-50%);
  .p1 {
    font-size: 22px;
    font-weight: bold;
    color: #fa4b4b;
    margin: 6px 0 12px 0;
    i {
      font-size: 14px;
    }
  }
  .p2 {
    font-size: 13px;
    color: #808080;
    text-decoration: line-through;
  }
  .p3 {
    font-size: 15px;
    font-weight: bold;
    color: #fa4b4b;
    margin: 6px 0 12px 0;
    line-height: 20px;
  }

  .num {
    margin: 12px 0 12px 0;
  }
  .addcert,
  .short,
  .forbid {
    display: inline-block;
    width: 100%;
    height: 32px;
    background-color: #fa4b4b;
    border-radius: 4px;
    @include font(14px, #ffffff, center, 400, 32px);
  }
  .short {
    background: rgb(255, 204, 81);
  }
  .forbid {
    background: #d8d8d8;
    color: #a0a0a0;
  }
}

.popup-info {
  .title {
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    margin-top: 60px;
    text-align: center;
    margin-bottom: 38px;
  }
  .btn {
    text-align: center;
    span {
      @include btn(124px, 44px, #fa4b4b, #ffffff, 16px, 2px);
    }
    .span2 {
      border: 1px solid #fa4b4b;
      color: #fa4b4b;
      background: none;
      margin-left: 20px;
    }
  }
  .close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
}
.header {
  height: 44px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f8f8f8;
  span {
    font-size: 17px;
    color: #333333;
    font-weight: bold;
    margin-left: 17px;
  }
  .close2 {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 20px;
    cursor: pointer;
  }
}
.middle {
  align-items: center;
  @include flex-d-c;
  img {
    width: 104px;
    height: 83px;
    margin: 12px 0;
  }
  span {
    font-size: 16px;
    color: #333333;
    padding: 20px 30px;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/goods-list-ceil-2.vue